/**
 * @generated SignedSource<<2dee5c99d8c5dd4f2da9d7e337251c70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GraphQLLlmConversationSource = "AGENT_EVAL_REGRESSION_JUDGE" | "ALERT_REMEDIATION" | "ALERT_RUNBOOK_HOOK" | "API" | "EVAL" | "INCIDENT" | "INTERNAL_AGENT" | "JOB" | "JOB_AGENT_DASHBOARD_SECTION" | "LINEAR" | "MCP_CLIENT" | "OPTIMIZER_CONFIGURATION" | "OPTIMIZER_ISSUE_REVISION" | "OPTIMIZER_PROPOSAL" | "OPTIMIZER_RUN" | "PR_IMPLEMENTATION" | "SLACK" | "STUDIO" | "SYSTEM" | "UI" | "WORKFLOW_MEMORY" | "WORKFLOW_MEMORY_CONSOLIDATE" | "WORKFLOW_MEMORY_EVAL" | "WORKFLOW_MEMORY_SHADOW_DIGEST" | "%future added value";
export type LlmConversationChatViewableQuery$variables = {
  id: any;
};
export type LlmConversationChatViewableQuery$data = {
  readonly node: {
    readonly conversationId?: number | null | undefined;
    readonly createdAt?: any;
    readonly id?: any;
    readonly metadataJson?: any | null | undefined;
    readonly source?: GraphQLLlmConversationSource | null | undefined;
    readonly sourceId?: string | null | undefined;
    readonly updatedAt?: any;
    readonly " $fragmentSpreads": FragmentRefs<"LlmConversationChatContent_llmConversation">;
  } | null | undefined;
};
export type LlmConversationChatViewableQuery = {
  response: LlmConversationChatViewableQuery$data;
  variables: LlmConversationChatViewableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metadataJson",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversationId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toolUseId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toolId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "query",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "artifactId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupTags",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayText",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "llmInteractionId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinking",
  "storageKey": null
},
v27 = [
  (v22/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "issueId",
    "storageKey": null
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipelineSlug",
  "storageKey": null
},
v29 = {
  "alias": "buildNumberInt",
  "args": null,
  "kind": "ScalarField",
  "name": "buildNumber",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logGroupNames",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repoName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "runId",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startIsoStr",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endIsoStr",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "namespace",
  "storageKey": null
},
v36 = [
  (v25/*: any*/),
  (v26/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "GraphQLMessageToolUse",
    "kind": "LinkedField",
    "name": "toolUse",
    "plural": false,
    "selections": [
      (v23/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "capabilityId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "input",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddLogsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddLogsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "DatadogLogsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddLogsAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddLogsAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "DatadogLogsAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddMetricsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddMetricsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "DatadogMetricsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddSpansStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddSpansEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "DatadogSpansToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddSpansAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddSpansAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "DatadogSpansAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddRumAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddRumAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "DatadogRumAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddEventsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddEventsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "DatadogEventsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddCIPipelineStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddCIPipelineEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "DatadogCIPipelineEventsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddCIPipelineAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddCIPipelineAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "DatadogCIPipelineEventsAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monitorId",
                "storageKey": null
              }
            ],
            "type": "DatadogMonitorToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceName",
                "storageKey": null
              }
            ],
            "type": "DatadogServiceDependencyToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v27/*: any*/),
            "type": "DatadogErrorTrackingIssueDetailsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "ddErrorTrackingStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "ddErrorTrackingEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "persona",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "track",
                "storageKey": null
              }
            ],
            "type": "DatadogErrorTrackingIssuesToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "queryParams",
                "storageKey": null
              },
              {
                "alias": "buildNumberStr",
                "args": null,
                "kind": "ScalarField",
                "name": "buildNumber",
                "storageKey": null
              }
            ],
            "type": "BuildkiteBuildsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stateFilter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "retryTypeFilter",
                "storageKey": null
              }
            ],
            "type": "BuildkiteLogsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contextFilter",
                "storageKey": null
              }
            ],
            "type": "BuildkiteAnnotationsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "artifactPath",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "searchQuery",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stepKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobName",
                "storageKey": null
              }
            ],
            "type": "BuildkiteArtifactsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "testSuiteSlug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "testName",
                "storageKey": null
              }
            ],
            "type": "BuildkiteFlakyTestToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "cwLogsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "cwLogsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              },
              (v30/*: any*/)
            ],
            "type": "CloudWatchLogsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "cwLogsAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "cwLogsAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              },
              (v30/*: any*/)
            ],
            "type": "CloudWatchLogsAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "cwMetricsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "cwMetricsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "CloudWatchMetricsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "gcLogsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "gcLogsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "GrafanaCloudLogsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "gcLogsAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "gcLogsAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "GrafanaCloudLogsAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "gcMetricsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "gcMetricsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "GrafanaCloudMetricsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "gcSpansAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "gcSpansAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "GrafanaCloudSpansAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "gcSpansStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "gcSpansEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "GrafanaCloudSpansToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "nrLogsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "nrLogsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "NewRelicLogsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "nrLogsAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "nrLogsAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "NewRelicLogsAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "nrMetricsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "nrMetricsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "NewRelicMetricsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "nrSpansStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "nrSpansEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "NewRelicSpansToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "nrSpansAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "nrSpansAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "NewRelicSpansAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "nrTransactionsStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "nrTransactionsEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "NewRelicTransactionsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v14/*: any*/),
              {
                "alias": "nrTransactionsAggStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "nrTransactionsAggEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "NewRelicTransactionsAggregationToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v31/*: any*/)
            ],
            "type": "QueryCodeToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/)
            ],
            "type": "GitHubActionsRunsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusFilter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conclusionFilter",
                "storageKey": null
              }
            ],
            "type": "GitHubActionsLogsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "channelId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "threadTs",
                "storageKey": null
              }
            ],
            "type": "SlackChannelContentsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "channelNameFilter",
                "storageKey": null
              },
              {
                "alias": "slackStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "slackEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "SlackChannelMetadataToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usergroupHandle",
                "storageKey": null
              }
            ],
            "type": "SlackUsergroupMentionToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "environment",
                "storageKey": null
              },
              {
                "alias": "sentryQueryParams",
                "args": null,
                "kind": "ScalarField",
                "name": "queryParams",
                "storageKey": null
              },
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "alias": "sentryIssuesStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "sentryIssuesEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "SentryIssuesToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v27/*: any*/),
            "type": "SentryIssueEventsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v35/*: any*/),
              (v14/*: any*/)
            ],
            "type": "TemporalWorkflowsToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowRunId",
                "storageKey": null
              }
            ],
            "type": "TemporalWorkflowHistoryToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tasks",
                "storageKey": null
              }
            ],
            "type": "UpdateTodoToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawInput",
                "storageKey": null
              }
            ],
            "type": "GenericToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": "ddDashboardId",
                "args": null,
                "kind": "ScalarField",
                "name": "dashboardId",
                "storageKey": null
              }
            ],
            "type": "DatadogDashboardToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notebookId",
                "storageKey": null
              }
            ],
            "type": "DatadogNotebookToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": "nrDashboardId",
                "args": null,
                "kind": "ScalarField",
                "name": "dashboardId",
                "storageKey": null
              }
            ],
            "type": "NewRelicDashboardToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": "nrChangeTrackingQuery",
                "args": null,
                "kind": "ScalarField",
                "name": "query",
                "storageKey": null
              },
              {
                "alias": "nrChangeTrackingStartIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "startIsoStr",
                "storageKey": null
              },
              {
                "alias": "nrChangeTrackingEndIsoStr",
                "args": null,
                "kind": "ScalarField",
                "name": "endIsoStr",
                "storageKey": null
              }
            ],
            "type": "NewRelicChangeTrackingToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dashboardId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dashboardSlug",
                "storageKey": null
              },
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "period",
                "storageKey": null
              }
            ],
            "type": "RootlyDashboardToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userQuery",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "domainFilter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numResults",
                "storageKey": null
              }
            ],
            "type": "SearchWebToolInput",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urls",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxCharacters",
                "storageKey": null
              }
            ],
            "type": "FetchWebContentToolInput",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/),
      (v15/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCapability",
        "kind": "LinkedField",
        "name": "capability",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parametersSchema",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "GraphQLMessageToolResult",
    "kind": "LinkedField",
    "name": "toolResult",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasData",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "commandFailed",
        "storageKey": null
      },
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLIntegrationQuerySource",
        "kind": "LinkedField",
        "name": "sources",
        "plural": true,
        "selections": [
          (v13/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLLlmConversation",
        "kind": "LinkedField",
        "name": "llmConversation",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v16/*: any*/),
      (v17/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ephemeral",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinkingSummary",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLMessageToolCall",
  "kind": "LinkedField",
  "name": "toolUse",
  "plural": false,
  "selections": (v36/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LlmConversationChatViewableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LlmConversationChatContent_llmConversation"
              }
            ],
            "type": "GraphQLLlmConversation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LlmConversationChatViewableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasUnreadResponse",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "last",
                    "value": 10
                  }
                ],
                "concreteType": "GraphQLLlmInteraction",
                "kind": "LinkedField",
                "name": "llmInteractions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusMessage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLAgentPendingQuestion",
                    "kind": "LinkedField",
                    "name": "pendingQuestions",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "questionsJson",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "answersJson",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "llmInteractions(last:10)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLFormattedMessage",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "messageRole",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "messageType",
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLMessageMetadata",
                    "kind": "LinkedField",
                    "name": "messageMetadata",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLUsageTokens",
                        "kind": "LinkedField",
                        "name": "usage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billingTokens",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "agentVersion",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLIntegrationQuerySource",
                        "kind": "LinkedField",
                        "name": "sources",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLMemoryAttribution",
                        "kind": "LinkedField",
                        "name": "memoryAttributions",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memoryId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memoryType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "memoryBody",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scope",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "knowledge",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "reasoning",
                                    "storageKey": null
                                  }
                                ],
                                "type": "GraphQLGenericLearningBody",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "queryType",
                                    "storageKey": null
                                  },
                                  (v22/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "queryDescription",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/)
                                ],
                                "type": "GraphQLQueryBody",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "resourceType",
                                    "storageKey": null
                                  },
                                  (v23/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "type": "GraphQLResourceBody",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourceType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "influenceReason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memorySummary",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "taskContexts",
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "output",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLChatAttachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "originalName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mimetype",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "size",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "downloadToken",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLMessageToolCall",
                    "kind": "LinkedField",
                    "name": "toolCalls",
                    "plural": true,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLAgentThoughtProcessItem",
                    "kind": "LinkedField",
                    "name": "agentThoughtProcess",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v37/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subagentDescription",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subagentOutput",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLAgentThoughtProcessItem",
                        "kind": "LinkedField",
                        "name": "subagentItems",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v38/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLAgentPendingToolUse",
                "kind": "LinkedField",
                "name": "pendingToolUses",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reviewedBy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reviewedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "llmConversationId",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "threadState",
                "storageKey": null
              }
            ],
            "type": "GraphQLLlmConversation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf9e8f82aaf58a8651b9e548f9f9b0b3",
    "id": null,
    "metadata": {},
    "name": "LlmConversationChatViewableQuery",
    "operationKind": "query",
    "text": "query LlmConversationChatViewableQuery(\n  $id: GlobalID!\n) {\n  node(id: $id) {\n    __typename\n    ... on GraphQLLlmConversation {\n      id\n      source\n      sourceId\n      metadataJson\n      createdAt\n      updatedAt\n      conversationId\n      ...LlmConversationChatContent_llmConversation\n    }\n    __isNode: __typename\n    id\n  }\n}\n\nfragment AgentThoughtProcess_formattedMessage on GraphQLFormattedMessage {\n  id\n  messageType\n  startedAt\n  endedAt\n  agentThoughtProcess {\n    text\n    thinking\n    thinkingSummary\n    subagentDescription\n    subagentOutput\n    subagentItems {\n      text\n      thinking\n      thinkingSummary\n      toolUse {\n        toolUse {\n          id\n          name\n        }\n        ...V2AgentThoughtProcessRenderer_toolCall\n        ...ToolCallSheet_toolCall\n        ...ChecklistToolCallResult_toolCall\n        ...SkillCluster_toolCall\n      }\n    }\n    toolUse {\n      toolUse {\n        id\n        name\n      }\n      ...V2AgentThoughtProcessRenderer_toolCall\n      ...ToolCallSheet_toolCall\n      ...ChecklistToolCallResult_toolCall\n      ...SkillCluster_toolCall\n    }\n  }\n}\n\nfragment AgentThoughtProcess_llmConversation on GraphQLLlmConversation {\n  id\n  threadState\n  pendingToolUses {\n    id\n    toolUseId\n    status\n    llmConversationId\n    llmInteractionId\n    conversationId\n  }\n}\n\nfragment ChecklistToolCallResult_toolCall on GraphQLMessageToolCall {\n  toolUse {\n    name\n    displayName\n    input {\n      __typename\n      ... on DatadogLogsToolInput {\n        question\n      }\n      ... on DatadogLogsAggregationToolInput {\n        question\n      }\n      ... on DatadogMetricsToolInput {\n        question\n      }\n      ... on DatadogSpansToolInput {\n        question\n      }\n      ... on DatadogSpansAggregationToolInput {\n        question\n      }\n      ... on DatadogRumAggregationToolInput {\n        question\n      }\n      ... on DatadogEventsToolInput {\n        question\n      }\n      ... on DatadogCIPipelineEventsToolInput {\n        question\n      }\n      ... on DatadogCIPipelineEventsAggregationToolInput {\n        question\n      }\n      ... on DatadogMonitorToolInput {\n        question\n      }\n      ... on DatadogServiceDependencyToolInput {\n        question\n      }\n      ... on DatadogErrorTrackingIssueDetailsToolInput {\n        question\n      }\n      ... on DatadogErrorTrackingIssuesToolInput {\n        question\n      }\n      ... on BuildkiteBuildsToolInput {\n        question\n      }\n      ... on BuildkiteLogsToolInput {\n        question\n      }\n      ... on BuildkiteAnnotationsToolInput {\n        question\n      }\n      ... on BuildkiteArtifactsToolInput {\n        question\n      }\n      ... on BuildkiteFlakyTestToolInput {\n        question\n      }\n      ... on CloudWatchLogsToolInput {\n        question\n      }\n      ... on CloudWatchLogsAggregationToolInput {\n        question\n      }\n      ... on CloudWatchMetricsToolInput {\n        question\n      }\n      ... on NewRelicLogsToolInput {\n        question\n      }\n      ... on NewRelicLogsAggregationToolInput {\n        question\n      }\n      ... on NewRelicMetricsToolInput {\n        question\n      }\n      ... on NewRelicSpansToolInput {\n        question\n      }\n      ... on NewRelicSpansAggregationToolInput {\n        question\n      }\n      ... on NewRelicTransactionsToolInput {\n        question\n      }\n      ... on NewRelicTransactionsAggregationToolInput {\n        question\n      }\n      ... on QueryCodeToolInput {\n        question\n      }\n      ... on GitHubActionsRunsToolInput {\n        question\n      }\n      ... on GitHubActionsLogsToolInput {\n        question\n      }\n      ... on SlackChannelContentsToolInput {\n        question\n      }\n      ... on SlackChannelMetadataToolInput {\n        question\n      }\n      ... on SlackUsergroupMentionToolInput {\n        usergroupHandle\n      }\n      ... on TemporalWorkflowsToolInput {\n        question\n      }\n      ... on TemporalWorkflowHistoryToolInput {\n        question\n      }\n      ... on UpdateTodoToolInput {\n        tasks\n      }\n      ... on GenericToolInput {\n        rawInput\n      }\n    }\n  }\n  toolResult {\n    content\n    sources {\n      toolId\n      title\n      description\n      type\n      displayText\n      artifactId\n      groupTags\n      query\n      link\n    }\n    llmConversation {\n      id\n    }\n  }\n}\n\nfragment LlmConversationChatContent_llmConversation on GraphQLLlmConversation {\n  id\n  source\n  sourceId\n  metadataJson\n  conversationId\n  createdAt\n  updatedAt\n  hasUnreadResponse\n  llmInteractions(last: 10) {\n    id\n    status\n    statusMessage\n  }\n  messages {\n    id\n    messageRole\n    messageType\n    content\n    messageMetadata {\n      usage {\n        billingTokens\n      }\n    }\n  }\n  ...LlmConversationMessageList_llmConversation\n}\n\nfragment LlmConversationMessageList_llmConversation on GraphQLLlmConversation {\n  id\n  pendingToolUses {\n    id\n    toolUseId\n    status\n    reviewedBy\n    reviewedAt\n  }\n  llmInteractions(last: 10) {\n    id\n    pendingQuestions {\n      id\n      toolUseId\n      questionsJson\n      answersJson\n      status\n    }\n  }\n  messages {\n    id\n    createdAt\n    updatedAt\n    messageRole\n    messageType\n    content\n    output\n    llmInteractionId\n    attachments {\n      originalName\n      mimetype\n      size\n      downloadToken\n    }\n    messageMetadata {\n      agentVersion\n    }\n    toolCalls {\n      ...ToolCallsSection_toolCalls\n      ...ChecklistToolCallResult_toolCall\n    }\n    agentThoughtProcess {\n      text\n      thinking\n      thinkingSummary\n      subagentDescription\n      subagentOutput\n      subagentItems {\n        text\n        thinking\n        thinkingSummary\n        toolUse {\n          ...ToolCallsSection_toolCalls\n        }\n      }\n      toolUse {\n        ...ToolCallsSection_toolCalls\n      }\n    }\n    ...messageWithToolReferences_formattedMessage\n    ...AgentThoughtProcess_formattedMessage\n  }\n  ...AgentThoughtProcess_llmConversation\n}\n\nfragment SkillCluster_toolCall on GraphQLMessageToolCall {\n  toolUse {\n    id\n    input {\n      __typename\n      ... on GenericToolInput {\n        rawInput\n      }\n    }\n  }\n}\n\nfragment ToolCallButton_toolCall on GraphQLMessageToolCall {\n  toolUse {\n    name\n    displayName\n    capabilityId\n    input {\n      __typename\n      ... on DatadogLogsToolInput {\n        question\n      }\n      ... on DatadogLogsAggregationToolInput {\n        question\n      }\n      ... on DatadogMetricsToolInput {\n        question\n      }\n      ... on DatadogSpansToolInput {\n        question\n      }\n      ... on DatadogSpansAggregationToolInput {\n        question\n      }\n      ... on DatadogRumAggregationToolInput {\n        question\n      }\n      ... on DatadogEventsToolInput {\n        question\n      }\n      ... on DatadogCIPipelineEventsToolInput {\n        question\n      }\n      ... on DatadogCIPipelineEventsAggregationToolInput {\n        question\n      }\n      ... on DatadogMonitorToolInput {\n        question\n      }\n      ... on DatadogServiceDependencyToolInput {\n        question\n      }\n      ... on DatadogErrorTrackingIssueDetailsToolInput {\n        question\n      }\n      ... on DatadogErrorTrackingIssuesToolInput {\n        question\n      }\n      ... on BuildkiteBuildsToolInput {\n        question\n      }\n      ... on BuildkiteLogsToolInput {\n        question\n      }\n      ... on BuildkiteAnnotationsToolInput {\n        question\n      }\n      ... on BuildkiteArtifactsToolInput {\n        question\n      }\n      ... on BuildkiteFlakyTestToolInput {\n        question\n      }\n      ... on CloudWatchLogsToolInput {\n        question\n      }\n      ... on CloudWatchLogsAggregationToolInput {\n        question\n      }\n      ... on CloudWatchMetricsToolInput {\n        question\n      }\n      ... on GrafanaCloudLogsToolInput {\n        question\n      }\n      ... on GrafanaCloudLogsAggregationToolInput {\n        question\n      }\n      ... on GrafanaCloudMetricsToolInput {\n        question\n      }\n      ... on GrafanaCloudSpansAggregationToolInput {\n        question\n      }\n      ... on GrafanaCloudSpansToolInput {\n        question\n      }\n      ... on NewRelicLogsToolInput {\n        question\n      }\n      ... on NewRelicLogsAggregationToolInput {\n        question\n      }\n      ... on NewRelicMetricsToolInput {\n        question\n      }\n      ... on NewRelicSpansToolInput {\n        question\n      }\n      ... on NewRelicSpansAggregationToolInput {\n        question\n      }\n      ... on NewRelicTransactionsToolInput {\n        question\n      }\n      ... on NewRelicTransactionsAggregationToolInput {\n        question\n      }\n      ... on QueryCodeToolInput {\n        question\n      }\n      ... on GitHubActionsRunsToolInput {\n        question\n      }\n      ... on GitHubActionsLogsToolInput {\n        question\n      }\n      ... on SlackChannelContentsToolInput {\n        question\n      }\n      ... on SlackChannelMetadataToolInput {\n        question\n      }\n      ... on SlackUsergroupMentionToolInput {\n        usergroupHandle\n      }\n      ... on SentryIssuesToolInput {\n        question\n        projectId\n        environment\n        sentryQueryParams: queryParams\n        startIsoStr\n        endIsoStr\n      }\n      ... on SentryIssueEventsToolInput {\n        question\n        issueId\n      }\n      ... on TemporalWorkflowsToolInput {\n        question\n      }\n      ... on TemporalWorkflowHistoryToolInput {\n        question\n      }\n      ... on UpdateTodoToolInput {\n        tasks\n      }\n    }\n  }\n  toolResult {\n    hasData\n    commandFailed\n  }\n}\n\nfragment ToolCallSheet_toolCall on GraphQLMessageToolCall {\n  toolUse {\n    id\n    name\n    displayName\n    capabilityId\n    link\n    capability {\n      id\n      name\n      parametersSchema\n    }\n    input {\n      __typename\n      ... on GenericToolInput {\n        rawInput\n      }\n      ... on DatadogLogsToolInput {\n        question\n        query\n        ddLogsStartIsoStr: startIsoStr\n        ddLogsEndIsoStr: endIsoStr\n      }\n      ... on DatadogLogsAggregationToolInput {\n        question\n        query\n        ddLogsAggStartIsoStr: startIsoStr\n        ddLogsAggEndIsoStr: endIsoStr\n      }\n      ... on DatadogMetricsToolInput {\n        question\n        query\n        ddMetricsStartIsoStr: startIsoStr\n        ddMetricsEndIsoStr: endIsoStr\n      }\n      ... on DatadogSpansToolInput {\n        question\n        query\n        ddSpansStartIsoStr: startIsoStr\n        ddSpansEndIsoStr: endIsoStr\n      }\n      ... on DatadogSpansAggregationToolInput {\n        question\n        query\n        ddSpansAggStartIsoStr: startIsoStr\n        ddSpansAggEndIsoStr: endIsoStr\n      }\n      ... on DatadogRumAggregationToolInput {\n        question\n        query\n        ddRumAggStartIsoStr: startIsoStr\n        ddRumAggEndIsoStr: endIsoStr\n      }\n      ... on DatadogEventsToolInput {\n        question\n        query\n        ddEventsStartIsoStr: startIsoStr\n        ddEventsEndIsoStr: endIsoStr\n      }\n      ... on DatadogCIPipelineEventsToolInput {\n        question\n        query\n        ddCIPipelineStartIsoStr: startIsoStr\n        ddCIPipelineEndIsoStr: endIsoStr\n      }\n      ... on DatadogCIPipelineEventsAggregationToolInput {\n        question\n        query\n        ddCIPipelineAggStartIsoStr: startIsoStr\n        ddCIPipelineAggEndIsoStr: endIsoStr\n      }\n      ... on DatadogDashboardToolInput {\n        question\n        ddDashboardId: dashboardId\n      }\n      ... on DatadogNotebookToolInput {\n        question\n        notebookId\n      }\n      ... on DatadogMonitorToolInput {\n        question\n        monitorId\n      }\n      ... on DatadogServiceDependencyToolInput {\n        question\n        serviceName\n      }\n      ... on DatadogErrorTrackingIssueDetailsToolInput {\n        question\n        issueId\n      }\n      ... on DatadogErrorTrackingIssuesToolInput {\n        question\n        query\n        ddErrorTrackingStartIsoStr: startIsoStr\n        ddErrorTrackingEndIsoStr: endIsoStr\n        persona\n        track\n      }\n      ... on BuildkiteBuildsToolInput {\n        question\n        pipelineSlug\n        queryParams\n        buildNumberStr: buildNumber\n      }\n      ... on BuildkiteLogsToolInput {\n        question\n        pipelineSlug\n        buildNumberInt: buildNumber\n        stateFilter\n        retryTypeFilter\n      }\n      ... on BuildkiteAnnotationsToolInput {\n        question\n        pipelineSlug\n        buildNumberInt: buildNumber\n        contextFilter\n      }\n      ... on BuildkiteArtifactsToolInput {\n        question\n        pipelineSlug\n        buildNumberInt: buildNumber\n        artifactPath\n        searchQuery\n        stepKey\n        jobName\n      }\n      ... on BuildkiteFlakyTestToolInput {\n        question\n        testSuiteSlug\n        testName\n      }\n      ... on CloudWatchLogsToolInput {\n        question\n        query\n        cwLogsStartIsoStr: startIsoStr\n        cwLogsEndIsoStr: endIsoStr\n        logGroupNames\n      }\n      ... on CloudWatchLogsAggregationToolInput {\n        question\n        query\n        cwLogsAggStartIsoStr: startIsoStr\n        cwLogsAggEndIsoStr: endIsoStr\n        logGroupNames\n      }\n      ... on CloudWatchMetricsToolInput {\n        question\n        query\n        cwMetricsStartIsoStr: startIsoStr\n        cwMetricsEndIsoStr: endIsoStr\n      }\n      ... on GrafanaCloudLogsToolInput {\n        question\n        query\n        gcLogsStartIsoStr: startIsoStr\n        gcLogsEndIsoStr: endIsoStr\n      }\n      ... on GrafanaCloudLogsAggregationToolInput {\n        question\n        query\n        gcLogsAggStartIsoStr: startIsoStr\n        gcLogsAggEndIsoStr: endIsoStr\n      }\n      ... on GrafanaCloudMetricsToolInput {\n        question\n        query\n        gcMetricsStartIsoStr: startIsoStr\n        gcMetricsEndIsoStr: endIsoStr\n      }\n      ... on GrafanaCloudSpansAggregationToolInput {\n        question\n        query\n        gcSpansAggStartIsoStr: startIsoStr\n        gcSpansAggEndIsoStr: endIsoStr\n      }\n      ... on GrafanaCloudSpansToolInput {\n        question\n        query\n        gcSpansStartIsoStr: startIsoStr\n        gcSpansEndIsoStr: endIsoStr\n      }\n      ... on NewRelicLogsToolInput {\n        question\n        query\n        nrLogsStartIsoStr: startIsoStr\n        nrLogsEndIsoStr: endIsoStr\n      }\n      ... on NewRelicLogsAggregationToolInput {\n        question\n        query\n        nrLogsAggStartIsoStr: startIsoStr\n        nrLogsAggEndIsoStr: endIsoStr\n      }\n      ... on NewRelicDashboardToolInput {\n        question\n        nrDashboardId: dashboardId\n      }\n      ... on NewRelicMetricsToolInput {\n        question\n        query\n        nrMetricsStartIsoStr: startIsoStr\n        nrMetricsEndIsoStr: endIsoStr\n      }\n      ... on NewRelicSpansToolInput {\n        question\n        query\n        nrSpansStartIsoStr: startIsoStr\n        nrSpansEndIsoStr: endIsoStr\n      }\n      ... on NewRelicSpansAggregationToolInput {\n        question\n        query\n        nrSpansAggStartIsoStr: startIsoStr\n        nrSpansAggEndIsoStr: endIsoStr\n      }\n      ... on NewRelicTransactionsToolInput {\n        question\n        query\n        nrTransactionsStartIsoStr: startIsoStr\n        nrTransactionsEndIsoStr: endIsoStr\n      }\n      ... on NewRelicTransactionsAggregationToolInput {\n        question\n        query\n        nrTransactionsAggStartIsoStr: startIsoStr\n        nrTransactionsAggEndIsoStr: endIsoStr\n      }\n      ... on NewRelicChangeTrackingToolInput {\n        question\n        nrChangeTrackingQuery: query\n        nrChangeTrackingStartIsoStr: startIsoStr\n        nrChangeTrackingEndIsoStr: endIsoStr\n      }\n      ... on QueryCodeToolInput {\n        question\n        repoName\n      }\n      ... on GitHubActionsRunsToolInput {\n        question\n        repoName\n        runId\n      }\n      ... on GitHubActionsLogsToolInput {\n        question\n        repoName\n        runId\n        statusFilter\n        conclusionFilter\n      }\n      ... on RootlyDashboardToolInput {\n        question\n        dashboardId\n        dashboardSlug\n        startIsoStr\n        endIsoStr\n        period\n      }\n      ... on SentryIssuesToolInput {\n        question\n        projectId\n        environment\n        sentryQueryParams: queryParams\n        sentryIssuesStartIsoStr: startIsoStr\n        sentryIssuesEndIsoStr: endIsoStr\n      }\n      ... on SentryIssueEventsToolInput {\n        question\n        issueId\n      }\n      ... on SlackChannelContentsToolInput {\n        question\n        channelId\n        threadTs\n      }\n      ... on SlackChannelMetadataToolInput {\n        question\n        channelNameFilter\n        slackStartIsoStr: startIsoStr\n        slackEndIsoStr: endIsoStr\n      }\n      ... on SlackUsergroupMentionToolInput {\n        usergroupHandle\n      }\n      ... on TemporalWorkflowsToolInput {\n        question\n        namespace\n        query\n      }\n      ... on TemporalWorkflowHistoryToolInput {\n        question\n        namespace\n        workflowId\n        workflowRunId\n      }\n      ... on UpdateTodoToolInput {\n        tasks\n      }\n      ... on SearchWebToolInput {\n        userQuery\n        domainFilter\n        numResults\n      }\n      ... on FetchWebContentToolInput {\n        urls\n        maxCharacters\n      }\n    }\n  }\n  toolResult {\n    content\n    hasData\n    commandFailed\n    artifactId\n    groupTags\n    ephemeral\n  }\n}\n\nfragment ToolCallsSection_toolCalls on GraphQLMessageToolCall {\n  text\n  thinking\n  ...ToolCallButton_toolCall\n  ...ChecklistToolCallResult_toolCall\n  ...ToolCallSheet_toolCall\n  ...V2ToolButton_toolCall\n  toolUse {\n    id\n    name\n    displayName\n    input {\n      __typename\n      ... on GenericToolInput {\n        rawInput\n      }\n    }\n  }\n  toolResult {\n    artifactId\n    groupTags\n  }\n}\n\nfragment V2AgentThoughtProcessRenderer_toolCall on GraphQLMessageToolCall {\n  toolUse {\n    name\n  }\n  ...V2ToolButton_toolCall\n}\n\nfragment V2ToolButton_toolCall on GraphQLMessageToolCall {\n  toolUse {\n    name\n    displayName\n    input {\n      __typename\n      ... on GenericToolInput {\n        rawInput\n      }\n    }\n  }\n  toolResult {\n    hasData\n    commandFailed\n    content\n  }\n}\n\nfragment messageWithToolReferences_formattedMessage on GraphQLFormattedMessage {\n  id\n  content\n  output\n  messageMetadata {\n    agentVersion\n    sources {\n      toolId\n      query\n      link\n      artifactId\n      groupTags\n      title\n      description\n      type\n      displayText\n    }\n    usage {\n      billingTokens\n    }\n    memoryAttributions {\n      memoryId\n      memoryType\n      memoryBody {\n        __typename\n        ... on GraphQLGenericLearningBody {\n          type\n          scope\n          knowledge\n          reasoning\n        }\n        ... on GraphQLQueryBody {\n          queryType\n          question\n          queryDescription\n          query\n        }\n        ... on GraphQLResourceBody {\n          resourceType\n          name\n          content\n        }\n      }\n      source\n      sourceType\n      influenceReason\n      memorySummary\n      taskContexts\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "35dd872cd91403414ad2d0a997b5bcec";

export default node;
